<mat-form-field style="width: 100%; margin: 0 0 -1em" *ngIf="showAbschnittStallAbteil()">
    <mat-label>Produktionsabschnitt</mat-label>
    <mat-select [formControl]="produktionsabschnittCtrl" [compareWith]="produktionsabschnittComparator">
        <mat-option *ngFor="let p of produktionsabschnitte" (onSelectionChange)="emitChanges()" [value]="p"
            >{{ p.produktionsabschnitt }}
        </mat-option>
    </mat-select>
</mat-form-field>
<div *ngIf="!isMobile">
    <div class="one-row">
        <kiene-autocomplete
            *ngIf="input?.kunde_id && showAbschnittStallAbteil()"
            #standortAutocomplete
            (deleteSelected)="deleteStall($event)"
            (elementSelected)="setStandort($event)"
            [displayFields]="['stall', 'sgs_nummer']"
            separator=", "
            [panelWidth]="'16%'"
            [emitFreeText]="true"
            [focus]="true"
            [genericApiUrl]="apiBaseUrl + 'gruppe/read_stall.php'"
            [kieneObject]="stall"
            [params]="params"
            [placeholder]="'Stall *'"
            [showClear]="false"
            [showDeleteButton]="true"
            style="width: 32%; margin: 0 0 -1em"
        >
        </kiene-autocomplete>

        <mat-form-field style="width: 32%; margin: 0 0 -1em" *ngIf="showAbschnittStallAbteil()">
            <mat-label>Abteil</mat-label>
            <input [formControl]="abteilCtrl" matInput type="text" (change)="emitChanges()" />
        </mat-form-field>

        <mat-form-field style="width: 32%; margin: 0 0 -1em">
            <mat-label>Gruppenname</mat-label>
            <input [formControl]="gruppennameCtrl" matInput type="text" (change)="emitChanges()" />
        </mat-form-field>
    </div>

    <ng-container *ngIf="showAnzahlDatumGewicht">
        <div class="one-row">
            <mat-form-field style="width: 32%; margin: 0 0 -1em">
                <mat-label>Anzahl Tiere</mat-label>
                <input [formControl]="anzahlTiereCtrl" matInput type="number" (change)="emitChanges()" />
            </mat-form-field>

            <mat-form-field style="width: 32%; margin: 0 0 -1em">
                <mat-label>Einstalldatum</mat-label>
                <input
                    [formControl]="einstalldatumVonCtrl"
                    [matDatepicker]="einstalldatum_von"
                    [readonly]="true"
                    matInput
                    (dateChange)="emitChanges()"
                />
                <mat-datepicker-toggle [for]="einstalldatum_von" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #einstalldatum_von></mat-datepicker>
            </mat-form-field>

            <ng-container *ngIf="!input?.gruppe_id">
                <mat-form-field style="width: 32%; margin: 0 0 -1em">
                    <mat-label>Einstallgewicht <small>pro Tier (kg)</small></mat-label>
                    <input [formControl]="einstallgewichtProTierCtrl" matInput type="number" (change)="emitChanges()" />
                </mat-form-field>
            </ng-container>
        </div>
    </ng-container>
</div>

<div *ngIf="isMobile" style="font-size: 75%">
    <kiene-autocomplete
        *ngIf="input?.kunde_id && showAbschnittStallAbteil()"
        (deleteSelected)="deleteStall($event)"
        (elementSelected)="setStandort($event)"
        [displayFields]="['stall', 'sgs_nummer']"
        separator=", "
        [emitFreeText]="true"
        [focus]="true"
        [genericApiUrl]="apiBaseUrl + 'gruppe/read_stall.php'"
        [kieneObject]="stall"
        [params]="params"
        [placeholder]="'Stall *'"
        [showClear]="false"
        [showDeleteButton]="true"
        style="width: 32%; margin: 0 0 -1em"
    >
    </kiene-autocomplete>

    <mat-form-field style="width: 100%; margin: 0 0 -1em" *ngIf="showAbschnittStallAbteil()">
        <mat-label>Abteil</mat-label>
        <input [formControl]="abteilCtrl" matInput type="text" (change)="emitChanges()" />
    </mat-form-field>

    <mat-form-field style="width: 100%; margin: 0 0 -1em">
        <mat-label>Gruppenname</mat-label>
        <input [formControl]="gruppennameCtrl" matInput type="text" (change)="emitChanges()" />
    </mat-form-field>

    <ng-container *ngIf="showAnzahlDatumGewicht">
        <mat-form-field style="width: 100%; margin: 0 0 -1em">
            <mat-label>Anzahl Tiere</mat-label>
            <input [formControl]="anzahlTiereCtrl" matInput type="number" (change)="emitChanges()" />
        </mat-form-field>

        <mat-form-field style="width: 100%; margin: 0 0 -1em">
            <mat-label>Einstalldatum</mat-label>
            <input
                [formControl]="einstalldatumVonCtrl"
                [matDatepicker]="einstalldatum_von"
                [readonly]="true"
                matInput
                (dateChange)="emitChanges()"
            />
            <mat-datepicker-toggle [for]="einstalldatum_von" matSuffix></mat-datepicker-toggle>
            <mat-datepicker #einstalldatum_von></mat-datepicker>
        </mat-form-field>

        <ng-container *ngIf="!input?.gruppe_id">
            <mat-form-field style="width: 100%; margin: 0 0 -1em">
                <mat-label>Einstallgewicht <small>pro Tier (kg)</small></mat-label>
                <input [formControl]="einstallgewichtProTierCtrl" matInput type="number" (change)="emitChanges()" />
            </mat-form-field>
        </ng-container>
    </ng-container>
</div>
<ng-container *ngIf="showAnzahlDatumGewicht">
    <div class="one-row">
        <b>Herkunftsbetrieb (opt.)</b>
        <button mat-icon-button color="accent" (click)="openHerkunftsBetriebDialog()">
            <mat-icon>edit</mat-icon>
        </button>
        <button *ngIf="kundeHerkunft" mat-icon-button color="accent" (click)="deleteHerkunftsbetrieb()">
            <mat-icon>delete</mat-icon>
        </button>
    </div>
    <h3 *ngIf="kundeHerkunft">{{ kundeHerkunft.bezeichnung }} {{ kundeHerkunft.zusatz }}</h3>
</ng-container>
